import { t } from 'i18next';
import z from 'zod';
import type { UpdatePasswordApiRequest } from '../types';

export const updatePasswordFormSchema = z
  .object({
    currentPassword: z
      .string()
      .min(
        1,
        t('features:account.components.settings_password_form.errors.current_password_required'),
      ),
    newPassword: z
      .string()
      .min(
        12,
        t('features:account.components.settings_password_form.errors.new_password_min_length'),
      ),
    confirmNewPassword: z
      .string()
      .min(
        1,
        t(
          'features:account.components.settings_password_form.errors.confirm_new_password_required',
        ),
      ),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: t(
      'features:account.components.settings_password_form.errors.confirm_new_password_mismatch',
    ),
    path: ['confirmNewPassword'],
  })
  .transform((data) => {
    return {
      current_password: data.currentPassword,
      password: data.newPassword,
    } satisfies UpdatePasswordApiRequest;
  });

type UpdatePasswordFormSchema = typeof updatePasswordFormSchema;

export type UpdatePasswordFormState = z.input<UpdatePasswordFormSchema>;
